// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".canvas__container canvas[data-v-1560dee2]{height:100%}.canvas__container.small[data-v-1560dee2]{height:12.5rem}.canvas__container.normal[data-v-1560dee2]{height:18.75rem}.canvas__container.large[data-v-1560dee2]{height:37.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
